module.exports = __webpack_public_path__ + "img/rr2.d8b56c0b.png";